import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from '../../../config/Translate';
import validator from 'validator';
import axios from 'axios';
import { defaultVariabls } from '../../../config/index';
import { withRouter} from "react-router";
import {withSnackbar} from "notistack";
import LoadingButton from "../../components/elements/LoadingButton";
import {connect, setStore} from "trim-redux";
import {Link} from 'react-router-dom';
import Button from "@material-ui/core/Button/Button";
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import Typography from "@material-ui/core/Typography/Typography";
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';
import Card from "@material-ui/core/Card/Card";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Avatar from "@material-ui/core/Avatar/Avatar";
import SubTitle from "./SubTitle";
import Divider from "@material-ui/core/Divider/Divider";
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import CardContent from "@material-ui/core/CardContent/CardContent";
import SendMessageToUserButton from "../../pages/admin/users/SendMessageToUserButton";
import AddTicketModalAdmin from "../../pages/tickets/add_ticket/AddTicketModalAdmin";

class details extends React.Component {
    classes = this.props.classes
    state={
        user:null,
        loading:true,
        id:this.props.id
    };
    componentDidMount(){
        this.loadData();
    }
    loadData(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.get(`${defaultVariabls.url}/user/get/${this.props.id}`, config)
            .then(response => {
                this.setState({
                   user:response.data,
                    loading:false,
                })
            })
            .catch(error => {
                this.setState({
                    loading:false
                })
            });
    }

    render() {
        const {user,loading} = this.state;
        let {primary_color,title} = this.props;
        if (loading) {
            return (
                <Card className="user_card">
                    <CardContent>
                        <CircularProgress style={{marginTop:10}}/>
                    </CardContent>
                </Card>
            )
        } else {
            return (
                <Card className="user_card">
                    <div className="user_card_content">
                        <div className="user_card_text">
                            <Avatar style={{width:75,height:75,margin:"auto"}} src={`${defaultVariabls.uploads}/FileManager/${user.avatar.name}_small.${user.avatar.extension}`}/>

                            <div className="user_card_info">
                                <SubTitle>{title} <span className={this.classes.primaryColor}>{user.first_name} {user.last_name}</span></SubTitle>
                                <Typography><a href={`tel:${user.mobile}`}>{user.mobile}</a></Typography>
                            </div>
                        </div>
                        <div style={{display:"flex",justifyContent:"space-between",flexDirection:"column"}}>
                            <Button
                                style={{marginTop:10}}
                                color="primary"
                                variant="outlined"
                                size="small"
                                component={Link}
                                to={`/manage/user/${user.id}`}
                                endIcon={<ChevronLeft/>}
                            >
                                {Translate.moreInfo}
                            </Button>
                            <AddTicketModalAdmin
                                receiver={user}
                                style={{marginTop:10}}
                                reload={() => console.log("reload")}
                            />
                        </div>

                    </div>
                </Card>
            );
        }
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(details))));